var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import PaginationActions from "../paginationactions/PaginationActions";
import _ from 'lodash';
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ToolBar from "../toolbar/ToolBar";
import { buttonTableCell, containedButton, textButton } from "../../../utils/styles";
import Highlight from "../highlight/Highlight";
import ColumnFilterSelect from "./ColumnFilterSelect";
import ColumnFilterTextField from "./ColumnFilterTextField";
import { Checkbox, Radio } from "@material-ui/core";
import Message from "../message/Message";
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return (__assign(__assign(__assign(__assign({ root: {}, toolbar: (_a = {
                paddingLeft: 0,
                paddingRight: 0,
                justifyContent: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                justifyContent: 'flex-end'
            },
            _a), spacer: (_b = {
                display: 'none'
            },
            _b[theme.breakpoints.up('sm')] = {
                display: 'inline-block'
            },
            _b), caption: (_c = {
                display: 'none'
            },
            _c[theme.breakpoints.up('sm')] = {
                display: 'inline-block'
            },
            _c), selectRoot: (_d = {
                marginLeft: 0,
                marginRight: 0
            },
            _d[theme.breakpoints.down('sm')] = {
                marginLeft: theme.spacing(),
                marginRight: theme.spacing(4)
            },
            _d) }, containedButton(theme, false, false)), textButton(theme)), buttonTableCell(theme)), { addButton: {
            marginRight: theme.spacing()
        } }));
});
export default function DataTable(props) {
    var rows = props.rows, columns = props.columns, _a = props.comparatorKeys, comparatorKeys = _a === void 0 ? [] : _a, _b = props.filter, filter = _b === void 0 ? false : _b, _c = props.filterOptions, filterOptions = _c === void 0 ? {
        filterByColumn: false,
        onFilter: function (value) { }
    } : _c, _d = props.sort, sort = _d === void 0 ? false : _d, _e = props.paginate, paginate = _e === void 0 ? false : _e, _f = props.paginateOptions, paginateOptions = _f === void 0 ? {
        resetPageOnRowsChange: true,
        startPage: 0,
        onChangePage: function (page) { },
        rowsPerPage: 5,
        onChangeRowsPerPage: function (rowsPerPage) { }
    } : _f, _g = props.lazyLoad, lazyLoad = _g === void 0 ? false : _g, _h = props.lazyLoadOptions, lazyLoadOptions = _h === void 0 ? {
        fetchId: '',
        total: 0,
        onFetch: function () { }
    } : _h, _j = props.select, select = _j === void 0 ? false : _j, _k = props.selectOptions, selectOptions = _k === void 0 ? {
        mode: 'multiple',
        selectedRows: [],
        onSelect: function (selectedRow, allSelectedRows) { }
    } : _k, toolbarContent = props.toolbarContent, _l = props.tableContainerProps, tableContainerProps = _l === void 0 ? {
        component: Paper
    } : _l, _m = props.hover, hover = _m === void 0 ? true : _m, rest = __rest(props, ["rows", "columns", "comparatorKeys", "filter", "filterOptions", "sort", "paginate", "paginateOptions", "lazyLoad", "lazyLoadOptions", "select", "selectOptions", "toolbarContent", "tableContainerProps", "hover"]);
    var classes = useStyles();
    var _o = useState(''), error = _o[0], setError = _o[1];
    var _p = useState(paginateOptions.startPage), page = _p[0], setPage = _p[1];
    var _q = useState(paginateOptions.rowsPerPage), rowsPerPage = _q[0], setRowsPerPage = _q[1];
    var _r = useState(''), filterValue = _r[0], setFilterValue = _r[1];
    var _s = useState(''), sortValue = _s[0], setSortValue = _s[1];
    var _t = useState(false), ascending = _t[0], setAscending = _t[1];
    var _u = useState(rows), filteredRows = _u[0], setFilteredRows = _u[1];
    var _v = useState([]), selectedRows = _v[0], setSelectedRows = _v[1];
    var _w = useState(), selected = _w[0], setSelected = _w[1];
    var columnsToFilter = useRef([]);
    useEffect(function () {
        if (select) {
            if (!comparatorKeys || comparatorKeys.length === 0) {
                setError('É necessário informar a propriedade "comparatorKeys"');
            }
        }
    }, []);
    useEffect(function () {
        setFilteredRows(rows);
        paginate && paginateOptions.resetPageOnRowsChange && lazyLoad === false && setPage(0);
    }, [rows, rows.length]);
    useEffect(function () {
        setPage(paginateOptions.startPage);
    }, [paginateOptions.startPage]);
    useEffect(function () {
        setPage(0);
        setFilterValue('');
        setSortValue('');
        setAscending(false);
    }, [lazyLoadOptions.fetchId]);
    useEffect(function () {
        setSelectedRows(selectOptions.selectedRows);
    }, [selectOptions.selectedRows.length]);
    var onChangePage = function (event, page) {
        setPage(page);
        paginate !== false && paginateOptions.onChangePage(page);
        lazyLoad !== false && lazyLoadOptions.onFetch(filterValue, sortValue, ascending, page, rowsPerPage);
    };
    var onChangeRowsPerPage = function (event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        paginate !== false && paginateOptions.onChangeRowsPerPage(parseInt(event.target.value, 10));
        lazyLoad !== false && lazyLoadOptions.onFetch(filterValue, sortValue, ascending, 0, parseInt(event.target.value));
    };
    var onFilter = function (value) {
        if (lazyLoad !== false) {
            lazyLoadOptions.onFetch(value, sortValue, ascending, 0, rowsPerPage);
        }
        else {
            if (!_.isEmpty(value)) {
                setFilteredRows(rows.filter(function (row) { return columns.some(function (column) {
                    var columnValue = column.valueGetter
                        ? column.valueGetter(_.get(row, column.field), row)
                        : _.get(row, column.field);
                    if (column.filterable !== false) {
                        if (column.customFilter && _.isFunction(column.customFilter)) {
                            // Comparação por um filtro customizado
                            return column.customFilter(value, _.get(row, column.field), row);
                        }
                        else {
                            // Comparação por "String.prototype.includes()"
                            return (_.has(row, column.field) && columnValue.toString().toUpperCase().includes(value.toUpperCase())
                                || (column.valueGetter && _.isString(columnValue) && columnValue.toString().toUpperCase().includes(value.toUpperCase())));
                        }
                    }
                    return false;
                }); }));
            }
            else {
                setFilteredRows(rows);
            }
        }
        setFilterValue(value);
        setPage(0);
        filterOptions.onFilter && filterOptions.onFilter(value);
        paginate !== false && paginateOptions.onChangePage(0);
    };
    var onFilterByColumn = function (columnIndex, column) { return function (value) {
        // Adiciona, remove ou atualiza as colunas/valores para filtragem.
        if (!columnsToFilter.current[columnIndex] // Adiciona
            && (value || !_.isEmpty(value) || typeof value === 'boolean' || typeof value === 'number')) {
            columnsToFilter.current[columnIndex] = {
                value: value,
                column: column
            };
        }
        else if (columnsToFilter.current[columnIndex] // Atualiza
            && (value || !_.isEmpty(value) || typeof value === 'boolean' || typeof value === 'number')) {
            columnsToFilter.current[columnIndex].value = value;
        }
        else { // Remove
            delete columnsToFilter.current[columnIndex];
        }
        // Realiza a filtragem.
        if (lazyLoad !== false) {
            // Corrigir posteriomente para filtrar por coluna/valor.
            lazyLoadOptions.onFetch(value, sortValue, ascending, 0, rowsPerPage);
        }
        else {
            setFilteredRows(Object.values(columnsToFilter.current).reduce(function (accumulator, columnToFilter) {
                return _filterByColumn(accumulator, columnToFilter.column, columnToFilter.value);
            }, rows));
        }
        setPage(0);
        filterOptions.onFilter && filterOptions.onFilter(value);
        paginate !== false && paginateOptions.onChangePage(0);
    }; };
    var _filterByColumn = function (rows, column, value) {
        return rows.filter(function (row) {
            var columnValue = column.valueGetter
                ? column.valueGetter(_.get(row, column.field), row)
                : _.get(row, column.field);
            if (column.filterable !== false) {
                if (column.customFilter && _.isFunction(column.customFilter)) {
                    // Comparação por um filtro customizado
                    return column.customFilter(value, _.get(row, column.field), row);
                }
                else {
                    // Comparação por "String.prototype.includes()"
                    return (_.has(row, column.field) && columnValue.toString().toUpperCase().includes(value.toString().toUpperCase())
                        || (column.valueGetter && _.isString(columnValue) && columnValue.toString().toUpperCase().includes(value.toString().toUpperCase())));
                }
            }
            return false;
        });
    };
    var onToggleAllRows = function () {
        var newSelectedRows;
        if (selectedRows.length) {
            newSelectedRows = [];
        }
        else {
            newSelectedRows = filteredRows;
        }
        setSelectedRows(newSelectedRows);
        selectOptions.onSelect(null, newSelectedRows);
    };
    var onToggleRow = function (row) { return function (event) {
        var newSelectedRows;
        // Adiciona
        if (event.target.checked) {
            newSelectedRows = __spreadArray(__spreadArray([], selectedRows, true), [row], false);
            selectOptions.onSelect(row, newSelectedRows);
            // Remove
        }
        else {
            newSelectedRows = selectedRows.filter(function (rowTemp) { return getComparatorValue(rowTemp) !== getComparatorValue(row); });
            selectOptions.onSelect(null, newSelectedRows);
        }
        setSelectedRows(newSelectedRows);
    }; };
    var onSelectRow = function (row) { return function () {
        setSelected(row);
        selectOptions.onSelect(row, null);
    }; };
    var getComparatorValue = useCallback(function (row) {
        return comparatorKeys.reduce(function (accumulator, key) { return accumulator + row[key]; }, '');
    }, [comparatorKeys, comparatorKeys.length]);
    var getColumnsLength = useCallback(function () {
        var accumulator = 0;
        select && accumulator++;
        accumulator += columns.length > 0 ? columns.filter(function (column) { return column.rendered !== false; }).length : 1;
        return accumulator;
    }, [columns, select]);
    var getTableRow = useCallback(function (row, rowIndex) {
        var comparatorValue = getComparatorValue(row);
        return (React.createElement(TableRow, { key: !!comparatorValue ? 'rowKey' + comparatorValue : 'rowKey' + rowIndex, hover: hover },
            select && (React.createElement(TableCell, { padding: "checkbox" }, selectOptions.mode === 'multiple' ? (React.createElement(Checkbox, { checked: selectedRows.some(function (rowTemp) { return getComparatorValue(rowTemp) === comparatorValue; }), onChange: onToggleRow(row), color: 'primary' })) : (React.createElement(Radio, { checked: !!selected && getComparatorValue(selected) === comparatorValue, onChange: onSelectRow(row), value: !!comparatorValue ? comparatorValue : 'tempRadioValue' + rowIndex, name: 'singleRadioGroup', color: 'primary' })))),
            columns.map(function (column, columnIndex) {
                var value = column.valueGetter
                    ? column.valueGetter(_.get(row, column.field), row)
                    : _.get(row, column.field);
                return column.rendered !== false && (React.createElement(TableCell, { key: 'columnKey' + comparatorValue + columnIndex, className: column.className }, column.filterable !== false && !React.isValidElement(value) && !column.customFilter ? (React.createElement(Highlight, { highlight: filterValue }, value + '')) : (value)));
            })));
    }, [columns, filterValue, selectedRows.length, selected]);
    return (React.createElement(React.Fragment, null,
        ((filter && !filterOptions.filterByColumn) || toolbarContent) && (React.createElement(ToolBar, { search: filter && !filterOptions.filterByColumn, onSearch: onFilter }, toolbarContent)),
        React.createElement(TableContainer, __assign({}, tableContainerProps),
            React.createElement(Table, __assign({}, rest),
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        select && selectOptions.mode === 'multiple' && (React.createElement(TableCell, { padding: 'checkbox' },
                            React.createElement(Checkbox, { indeterminate: selectedRows.length > 0 && selectedRows.length < rows.length, checked: !error && selectedRows.length > 0 && selectedRows.length === rows.length, onChange: onToggleAllRows, inputProps: { 'aria-label': 'Selecionar todos' }, disabled: !!error, color: 'primary' }))),
                        select && selectOptions.mode === 'single' && (React.createElement(TableCell, { padding: "checkbox" })),
                        columns.map(function (column, columnIndex) { return column.rendered !== false && (React.createElement(TableCell, { key: column.label + columnIndex },
                            column.label,
                            filterOptions.filterByColumn && column.filterable && (React.createElement(React.Fragment, null, column.filterOptions ? (React.createElement(ColumnFilterSelect, { id: "select".concat(columnIndex), filterOptions: column.filterOptions, onChange: onFilterByColumn(columnIndex, column) })) : (React.createElement(ColumnFilterTextField, { id: "textField".concat(columnIndex), onChange: onFilterByColumn(columnIndex, column) })))))); }))),
                React.createElement(TableBody, null,
                    !error && (paginate !== false && lazyLoad === false
                        ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(getTableRow)
                        : filteredRows.map(getTableRow)),
                    !error && !filteredRows.length && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: getColumnsLength() }, "Nenhum registro encontrado."))),
                    !!error && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: getColumnsLength() },
                            React.createElement(Message, { type: 'error' }, error)))))),
            (paginate !== false || lazyLoad !== false) && filteredRows.length > 0 && (React.createElement(TablePagination, { classes: { toolbar: classes.toolbar, selectRoot: classes.selectRoot, spacer: classes.spacer, caption: classes.caption }, component: 'div', labelDisplayedRows: function (_a) {
                    var from = _a.from, to = _a.to, count = _a.count;
                    return "".concat(from, " at\u00E9 ").concat(to, " de ").concat(count, " registro(s)");
                }, labelRowsPerPage: '', rowsPerPageOptions: [5, 10, 25], count: lazyLoad !== false ? lazyLoadOptions.total : filteredRows.length, rowsPerPage: Number(rowsPerPage), page: page, onPageChange: onChangePage, onRowsPerPageChange: onChangeRowsPerPage, ActionsComponent: PaginationActions })))));
}
